<template>
    <div>
        <h2 class="mb-3" v-html="$t('intern_paymentdata.topic')"></h2>

        <div v-if="sepaDetails" class="border rounded p-3 mb-5">
          <label v-html="$t('intern_paymentdata.deposited_bank_details')"></label>

          {{sepaDetails.bank_name}} ({{sepaDetails.iban_masked}})
          <label> Das Mandat wurde am {{sepaDetails.created_date}} um {{sepaDetails.created_time}} Uhr erteilt </label>
        </div>

        <div class="border rounded p-3 mb-3">
          <h4 class="mb-4" v-html="$t('intern_paymentdata.change_bank_details_label')"></h4>

          <div v-if="err != null" class="alert alert-danger" role="alert">
              {{this.err}}
          </div>

          <div v-if="success != ''" class="alert alert-success" role="alert">
              {{this.success}}
          </div>

          <div class="row form-group">
              <div class="col-md-6 mb-4">
                    <span class="" v-html="$t('intern_bankdata.bank')"></span>
                    <input type="text" class="form-control" name="sepa[bank]" v-model.trim="bankname">
              </div>

              <div class="col-md-6">
                    <span class="" v-html="$t('intern_bankdata.owner')"></span>
                    <input type="text" class="form-control" name="sepa[owner]" v-model.trim="owner" @blur="$v.owner.$touch()" :class="{ 'is-invalid': $v.owner.$error }" >
                    <div class="invalid-feedback" v-if="!$v.owner.required">Bitte Konto-inhaber eingeben</div>
              </div>
          </div>
          <div class="row form-group">
              <div class="col-md-6 mb-4">
                  <span class="" v-html="$t('intern_bankdata.bic')"></span>
                  <input type="text" class="form-control" name="sepa[bic]" v-model.trim="bic" @blur="$v.bic.$touch()" :class="{ 'is-invalid': $v.bic.$error }" >
                  <div class="invalid-feedback" v-if="!$v.bic.required">Bitte BIC eingeben</div>
              </div>

              <div class="col-md-6">
                  <span class="" v-html="$t('intern_bankdata.iban')"></span>
                  <input type="text" class="form-control" name="sepa[iban_new]" v-model.trim="iban" @blur="$v.iban.$touch()" :class="{ 'is-invalid': $v.iban.$error }">
                  <div class="invalid-feedback" v-if="!$v.iban.required">Bitte IBAN eingeben</div>
              </div>
          </div>

          <div>
              <span v-html="$t('intern_bankdata.legal_info')"></span>
          </div>
          <div class="clearfix mt-3">
              <button class="btn btn-success float-right" @click="updateSepaMandate">{{$t('intern_paymentdata.button_issue_mandate')}}</button>
          </div>
        </div>

        <div v-if="isMobile">

        </div>
    </div>
</template>

<script>
    import { IsMobileMixin } from '../../mixins/IsMobile';
    import {required} from "vuelidate/lib/validators";

    export default {
        name: 'konto-zahlungsdaten',
        data() {
            return {
              sepaDetails: this.$store.getters.sepaDetails,
              bankname: '',
              owner: '',
              bic: '',
              iban: '',
              err : null,
              success: '',
            }
        },
        mixins: [IsMobileMixin],
        methods: {
          updateSepaMandate(){
              this.$store.state.loading = true;

              const bankdata = {
                bankname : this.bankname,
                owner : this.owner,
                bic : this.bic,
                iban : this.iban
              }
              this.$http.put('UserApi/IssueNewSepaMandate', bankdata).then(response => {
                if(response.status == 'success'){
                  const data = JSON.parse(response.data);
                  this.success = data.msg;
                  this.$store.dispatch('SEPA_DETAILS'); //this will the SEPA Mandate details
                }
              }).catch(error => {
                let data = JSON.parse(error.response.data.data);
                this.err = data.msg;
              }).then(() => {
                this.$store.state.loading = false;
              });
          }
        },
        created() {
            document.title = 'Meine Zahlungsdaten';

            this.$store.dispatch('SEPA_DETAILS'); //this will the SEPA Mandate details

            this.$store.watch(() => {
                  return this.$store.getters.sepaDetails;
            }, sepaDetails => {
                this.sepaDetails = sepaDetails;
            });
        },
        validations: {
            owner: {required},
            bic: {required},
            iban: {required}
        }
    }
</script>

<style scoped>
.input-group-text{
  border : 1px solid #808080 !important;
}
.form-control{
  border : 2.3px solid #808080 !important;
  border-radius: 5px !important;
}
.search{
    width: 15px;
    height: 15px;
    position: absolute;
    top: 12px;
    right: 10px;
    cursor: pointer;
}
</style>
